import blog1 from  '../img/blogs/blog1.svg';
import blog2 from  '../img/blogs/blog2.svg';
import blog3 from  '../img/blogs/blog3.svg';
import blog4 from  '../img/blogs/blog4.svg';
import etc from  '../img/blogs/etc.png';
import icpc from  '../img/blogs/icpc2.png';
import cp from  '../img/blogs/cp.png';
import re from  '../img/blogs/re.png';


const blogs = [
    {
        id: 1,
        title: '⭐ Accomplished a Rank of 10 in  Jane Street’s Virtual ETC among 162 groups in Australia (April 2021)',
        date: '01',
        month: 'April 2021',
        image: etc,
        // link: 'https://auth.geeksforgeeks.org/user/nirmalyasaha/practice/'
    },
    {
        id: 2,
        title: '⭐ Scored a Rank of 36 in ANZAC round for Competitive Programming among 236 groups in Australia (Nov 2021)',
        date: '01',
        month: 'April',
        image: cp,
        // link: 'https://www.codechef.com/users/nirmalya_saha'
    },
    {
        id: 3,
        title: '⭐ Achieved a Rank of 41 in (ICPC) Regional 2021 among more than 500+ group in Australia (Jan 2021)',
        date: '01',
        month: 'April',
        image: icpc,
        // link: 'https://www.qwiklabs.com/public_profiles/c537e8e5-a0df-4f4f-9feb-b95acfb46f98'
    },
    {
        id: 4,
        title: '⭐ Youngest Student Researcher in Parsons Puzzle underlead the of Dr. Cheryl Pope (Jan 2021)',
        date: '01',
        month: 'April',
        image: re,
        // link: 'https://docs.microsoft.com/en-in/users/nirmalyasaha-1437/?WT.mc_id=welcome_2_control_video_-email-learn'
    }
    // {
    //     id: 5,
    //     title: '⭐ Surpassed 4 Internships during my Bachelor’s degree (Jan - Nov 2021)',
    //     date: '01',
    //     month: 'April',
    //     image: blog1,
    //     // link: 'https://github.com/Nirmalya-Saha96'
    // },
    // {
    //     id: 6,
    //     title: '⭐ Excelled in earning a Full-Time Job offer in the 2nd Year of my degree at ACURA (Dec 2021)',
    //     date: '01',
    //     month: 'April',
    //     image: blog2,
    //     // link: 'https://github.com/Nirmalya-Saha96'
    // }
]

export default blogs;
